import { render } from "./InstructorCard.vue?vue&type=template&id=7ece771c&scoped=true"
import script from "./InstructorCard.vue?vue&type=script&lang=js"
export * from "./InstructorCard.vue?vue&type=script&lang=js"

import "./InstructorCard.vue?vue&type=style&index=0&id=7ece771c&lang=sass&scoped=true"

import exportComponent from "../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ece771c"]])

export default __exports__